import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=cec19eaa&scoped=true&"
import script from "./infoDetail.vue?vue&type=script&lang=js&"
export * from "./infoDetail.vue?vue&type=script&lang=js&"
import style0 from "./infoDetail.vue?vue&type=style&index=0&id=cec19eaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec19eaa",
  null
  
)

export default component.exports